import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import { NgbDatepickerModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { TranslateModule } from '@ngx-translate/core';

import { PrimitivesModule } from '../primitives/primitives.module';

import { FormPopupComponent } from './form-popup/form-popup.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { CustomTooltipShellComponent } from './custom-tooltip-shell/custom-tooltip-shell.component';
import { DateFieldSelectorComponent } from './date-field-selector/date-field-selector.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { GraphLoaderComponent } from './graph-loader/graph-loader.component';
import { MenuPopupComponent } from './menu-popup/menu-popup.component';
import { StepperComponent } from './stepper/stepper.component';

const NON_PRIMITIVES = [
  ConfirmationDialogComponent,
  CustomTooltipShellComponent,
  DateFieldSelectorComponent,
  DateRangeComponent,
  EmptyStateComponent,
  GraphLoaderComponent,
  // Forms
  FormPopupComponent,
  // Toolbars
  ToolbarComponent,
  // Popups
  MenuPopupComponent,
  StepperComponent,
];

@NgModule({
  declarations: NON_PRIMITIVES,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    PrimitivesModule,
    MatDialogModule,
    MatSelectModule,
    MatFormFieldModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbTooltipModule,
    TranslateModule,
  ],
  exports: NON_PRIMITIVES,
})
export class NonPrimitivesModule { }
